var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"poster",attrs:{"id":"poster"}}),_c('vue-qr',{staticStyle:{"display":"none"},attrs:{"id":"qr","text":_vm.url}}),_c('div',{staticClass:"last-poster",attrs:{"id":"lastPoster"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }